import { useLazyLoadQuery } from 'react-relay';
import { graphql } from 'relay-runtime';
import { useToken, useInfo } from '../../../Flow/ConsentContextProvider';
import { getPluginCollaboratorsQuery } from '#generated/graphql/getPluginCollaboratorsQuery.graphql';

const query = graphql`
  query getPluginCollaboratorsQuery($appId: ID!) {
    trello {
      application(id: $appId) @optIn(to: "TrelloApplication") {
        id
        collaborators {
          user {
            accountId
          }
        }
      }
    }
  }
`;

const toAppAri = (appId: string) => `ari:cloud:trello::application/${appId}`;

/**
 * Returns true if the current user is an author or collaborator of the Trello
 * app identified by appId.
 */
export function useApplicationCollaboratorAccessCheck(): boolean {
  const { userId } = useToken();
  const info = useInfo();
  // appId is guaranteed to be set by AccessGate before this hook is called
  const appId = info.client!.appId!;
  const appAri = toAppAri(appId);

  const response = useLazyLoadQuery<getPluginCollaboratorsQuery>(
    query,
    { appId: appAri },
    { fetchKey: appAri },
  );

  const application = response.trello?.application;
  if (!application) {
    return false;
  }

  return (application.collaborators ?? []).some(
    (collaborator) => collaborator.user?.accountId === userId,
  );
}
